"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
const notification_center_models_1 = require("@forto-dev/notification-center-models");
exports.translations = {
    surveyName: `survey-name-${notification_center_models_1.SurveyType.MoTUsefulness}`,
    note: 'mot-survey-note',
    youWillNotReceiveWarning: 'mot-survey-you-will-not-receive-warning',
    weValueYourFeedback: 'mot-survey-we-value-your-feedback',
    confirm: 'mot-survey-confirm',
    next: 'mot-survey-next',
    cancel: 'common-action-cancel',
    close: 'common-action-close',
    done: 'common-action-done',
    submit: 'mot-survey-submit',
    configure: 'mot-survey-configure-button',
    tellUsMore: 'mot-survey-tell-us-more',
    takeAFewMoments: 'mot-survey-take-a-few-moments',
    feedbackHasBeenSubmitted: 'mot-survey-feedback-has-been-submitted',
    viewYourShipments: 'mot-survey-view-your-shipments',
    feedbackHasBeenSubmittedShort: 'mot-survey-feedback-has-been-submitted-short',
    thankYou: 'mot-survey-thank-you',
    additionalInformation: 'mot-survey-additional-information',
    unsubscribedSuccessfully: 'manage_notifications-unsubscription-confirmation_plaintext',
};
//# sourceMappingURL=translations.js.map